<div #rxAppPrintContainer class="print-rx-container"></div>